import Alpine from "alpinejs";

Alpine.data('videoPlayer', () => ({
    currentVideo: 0,
    nextVideo: 0,
    currentLayer: 0,
    videos: [],
    ribbonVideos: [],
    itemHeight: 108, // Height of each item, including padding/margin
    totalItems: 0, // Total items in the ribbon
    offset: -108, // Initial offset to show the first item

    initVideos(videos) {
        this.videos = videos || [];
        if (this.videos.length > 0) {
            this.setupCarousel();
            this.loadImage(0);
            setInterval(() => {
                this.crossFadeSwitchImage();
            }, 5000); // Change image every 5 seconds
        }
    },

    setupCarousel() {
        this.ribbonVideos = [...this.videos, ...this.videos];
        this.totalItems = this.ribbonVideos.length;
    },

    loadImage(layer) {
        const video = this.videos[this.currentVideo];
        this[`$refs`][`imagePlayer${layer + 1}`].src = video.src;
    },

    crossFadeSwitchImage() {
        this.nextVideo = (this.currentVideo + 1) % this.videos.length;

        // First, move the ribbon
        this.moveRibbon(() => {
            // Then load the next image and update the text after the ribbon has moved
            this.currentLayer = 1 - this.currentLayer;
            this.currentVideo = this.nextVideo;
            this.loadImage(this.currentLayer);
        });
    },

    setCurrentVideo(index) {
        this.nextVideo = index % this.videos.length;

        // First, move the ribbon
        this.moveRibbonToIndex(index, () => {
            // Then load the selected image and update the text after the ribbon has moved
            this.currentLayer = 1 - this.currentLayer;
            this.currentVideo = this.nextVideo;
            this.loadImage(this.currentLayer);
        });
    },

    moveRibbon(callback) {
        this.offset -= this.itemHeight;

        const carousel = this.$refs.carousel;

        if (!carousel) {
            console.error('Carousel element is not found.');
            return;
        }

        carousel.style.transform = `translateY(${this.offset}px)`;
        carousel.style.transition = 'transform 0.5s ease-in-out';

        setTimeout(() => {
            if (Math.abs(this.offset) >= this.itemHeight * this.videos.length) {
                this.isResetting = true;
                this.offset = 0;
                carousel.style.transition = 'none';
                carousel.style.transform = `translateY(${this.offset}px)`;
                requestAnimationFrame(() => {
                    this.isResetting = false;
                    if (typeof callback === 'function') callback();
                });
            } else {
                if (typeof callback === 'function') callback();
            }
        }, 500); // Match this to the CSS transition duration
    },

    moveRibbonToIndex(index, callback) {
        this.offset = -index * this.itemHeight;

        const carousel = this.$refs.carousel;

        if (!carousel) {
            console.error('Carousel element is not found.');
            return;
        }

        carousel.style.transform = `translateY(${this.offset}px)`;
        carousel.style.transition = 'transform 0.5s ease-in-out';

        setTimeout(() => {
            if (typeof callback === 'function') callback();
        }, 500); // Match this to the CSS transition duration
    }
}));